import type { IconData } from '@stacksjs/iconify-core'

export const dashboardGauge2Flat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 4.5c12.426 0 22.5 10.074 22.5 22.5c0 3.264-.684 7.178-2.138 10.053c-.872 1.726-2.674 2.447-4.284 2.447H7.922c-1.61 0-3.412-.721-4.284-2.447C2.184 34.178 1.5 30.263 1.5 27C1.5 14.574 11.574 4.5 24 4.5\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M24 12.509c-8.341 0-15 6.548-15 14.5c0 1.69.299 3.31.847 4.815a2 2 0 1 1-3.759 1.37A18 18 0 0 1 5 27.008c0-10.273 8.563-18.5 19-18.5s19 8.227 19 18.5c0 2.166-.383 4.248-1.088 6.184a2 2 0 1 1-3.759-1.369A14 14 0 0 0 39 27.01c0-7.952-6.659-14.5-15-14.5\" clip-rule=\"evenodd\"/><path fill=\"#2859c5\" d=\"M31.073 21.26a2.5 2.5 0 1 0-4.83-1.294l-3.39 12.654A5.502 5.502 0 0 0 24 43.5a5.5 5.5 0 0 0 3.683-9.585z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default dashboardGauge2Flat
